<script lang="ts" generics="T extends { id:number, name:string, vertical:string, address?:{suburb:string} }">
	import { merchantNameSuburbSlug, slugify } from "$lib/util/format";
	import SeoBrandsDisplay from "./SeoBrandsDisplay.svelte";

	const ELIPSE_RADIUS = 2;

  export let data: {
		list:T[],
		index: number,
		total: number,
		perPage: number,
	};

	$: links = pages(data.index, data.total, data.perPage);

	function page(list: T[]) {
		let letters: Record<string, T[]> = {};
		let currentLetter: string;

		list.forEach(item => {
		if (item.name && currentLetter !== item.name[0].toLowerCase()) {
				currentLetter = item.name[0].toLowerCase();
				letters[currentLetter] = []
			}
			letters[currentLetter]?.push(item);
		});
		return letters;
	}

	function pages(index:number, total:number, perPage:number) {
		const lastPageIndex = Math.ceil(total / perPage) - 1;
		const links = [];
		let pushedElipse = false;
		for (let i = 0; i < lastPageIndex; i++) {
			if (Math.abs(index - i) < ELIPSE_RADIUS || i < ELIPSE_RADIUS || lastPageIndex - i <= ELIPSE_RADIUS) {
				links.push(i);
				pushedElipse = false;
			} else if (!pushedElipse) {
				links.push(null);
				pushedElipse = true;
			}
		}
		return links;
	}

</script>

<section class="brands-glossary">
	{#if data.list}
		{@const letters = page(data.list)}
		{#each Object.keys(letters) as letter, i}
			<article class="gloss">
				<div class="headline-s bold letter">{letter.toUpperCase()}</div>
				<SeoBrandsDisplay list={letters[letter]} noMargin={true} genHref={item => `/delivery/${item.vertical}/${merchantNameSuburbSlug(item.name,item.address?.suburb)}/${item.id}`}/>
			</article>
		{/each}
	{/if}

	<article class="switch">
		{#if data.index}
			<a class="prev" href={`/delivery/restaurants-near-me/${(data.index) || ''}`}><span class="icon-chevron-left-28"></span></a>
		{/if}

		<div class="jump-links">
			{#each links as link}
				<article>
					{#if link === null}
						<span>...</span>
					{:else}
						<a href={`/delivery/restaurants-near-me/${link ? link + 1 : ''}`} class="headline-s" class:active={data.index === link}>{link + 1}</a>
					{/if}
				</article>
			{/each}
		</div>

		{#if data.index < Math.ceil(data.total / data.perPage) - 2}
			<a class="next" href={`/delivery/restaurants-near-me/${data.index+2}`}><span class="icon-chevron-right-28"></span></a>
		{/if}
	</article>
	
</section>

<style lang="scss">
	@use 'color';
	@use 'screen';
	.brands-glossary {
		margin: 3rem 0;
		article.gloss {
			padding: 1.5rem 0;
			border-top: 2px solid color.$separator;
			@media(screen.$mdl) { padding: 3rem 0; }
			@media(screen.$mdl) {
				display: flex;
				align-items: flex-start;
			}
			.letter {
				margin-bottom: 1.7rem;
				color: color.$on-background-medium-importance;
				@media(screen.$mdl) { margin-right: 5rem; margin-bottom: 0; }
				@media(screen.$lg) { margin-right: 8rem; }
				@media(screen.$xl) { margin-right: 10rem; }
			}
		}
		article.switch {
			position: relative;
			display: flex;
			justify-content: center;
			padding: 2rem 0;
			@media(min-width: 440px) {
				padding: 3rem 0;
				border-top: 2px solid color.$separator;
				border-bottom: 2px solid color.$separator;
			}
			>a {
				position: absolute;
				top: 100%;
				border: 2px solid color.$object-elevation-12dp;
				border-radius: 50%;
				width: 40px;
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				@media(min-width: 440px) {
					top: 50%;
					transform: translateY(-50%);
				}
				&.prev {
					left: 25%;
					@media(min-width: 440px) { left: 0; }
				}
				&.next {
					right: 25%;
					@media(min-width: 440px) { right: 0; }
				}
				>span { transform: translateY(2px); }
			}
			.jump-links {
				display: flex;
				align-items: flex-end;
				article {
					a {
						color: color.$on-background-low-importance;
						font-weight: 500;
						margin: 0 0.3rem;
						min-width: 34px;
						display: inline-flex;
						justify-content: center;
						align-items: center;
						&.active {
							position: relative;
							color: color.$on-surface;
							&:after {
								position: absolute;
								top: -6px;
								left: -5px;
								width: calc(100% + 10px);
								height: calc(100% + 12px);
								content: '';
								border: 2px solid color.$on-surface;
								border-radius: 50%;
							}
						}
					}
					&:last-child {
						a { margin-right: 0; }
					}
				}
				span {
					color: color.$on-background-low-importance;
					display: inline-block;
					font-size: 1.5rem;
					letter-spacing: 0.1rem;
				}
			}
		}
	}
</style>